import { memo } from 'react'
import { createPortal } from 'react-dom'
import PayoffSettingsButton from './payoffSettingsButton'

type Props = {
    container: HTMLElement | null
    readOnly: boolean
    width: number
    onOpen: () => void
}

const PayoffChartSettingsOverlay = ({ container, readOnly, width, onOpen }: Props) => {
    if (readOnly || !container) return null
    return createPortal(<PayoffSettingsButton width={width} onClick={onOpen} />, container)
}

export default memo(
    PayoffChartSettingsOverlay,
    (prev, next) =>
        prev.container === next.container &&
        prev.readOnly === next.readOnly &&
        prev.width === next.width &&
        prev.onOpen === next.onOpen
)
